"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFilterOption = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var DateConversions_1 = require("../utils/DateConversions");
var locales_1 = require("../../locales");
var validateVisibility = function (filterOption) {
    var errors = {};
    if (!filterOption.visible) {
        // indicate that the Apply button should be disabled, it makes no sense for hidden forms
        errors[filterOption.type] = {};
    }
    return errors;
};
var validateAbsoluteForm = function (filterOption) {
    var errors = validateVisibility(filterOption);
    var absoluteFormKeys = ["from", "to"];
    absoluteFormKeys.forEach(function (field) {
        if (!filterOption[field]) {
            errors.absoluteForm = errors.absoluteForm || {};
            // null means empty, undefined means invalid
            // this is dictated by react-day-picker that returns undefined on invalid values
            if (filterOption[field] === undefined) {
                errors.absoluteForm[field] = locales_1.messages.incorrectFormat.id;
            }
        }
    });
    if (!errors.absoluteForm) {
        var start = DateConversions_1.convertPlatformDateStringToDate(filterOption.from);
        var end = DateConversions_1.convertPlatformDateStringToDate(filterOption.to);
        if (start > end) {
            errors.absoluteForm = { to: locales_1.messages.endDateBeforeStartDate.id };
        }
    }
    return errors.absoluteForm ? errors : {};
};
var validateRelativeForm = function (filterOption) {
    var errors = validateVisibility(filterOption);
    var relativeFormKeys = ["from", "to"];
    relativeFormKeys.forEach(function (field) {
        if (filterOption[field] === undefined) {
            errors.relativeForm = errors.relativeForm || {};
            // There is no validation message as we have no place to show it
        }
    });
    return errors.relativeForm ? errors : {};
};
exports.validateFilterOption = function (filterOption) {
    if (sdk_model_1.isAbsoluteDateFilterForm(filterOption)) {
        return validateAbsoluteForm(filterOption);
    }
    else if (sdk_model_1.isRelativeDateFilterForm(filterOption)) {
        return validateRelativeForm(filterOption);
    }
    else {
        return validateVisibility(filterOption);
    }
};
//# sourceMappingURL=OptionValidation.js.map